import { Container } from './Container';

export type { TypeContainerProps } from './types';

export default Container;
